export default __webpack_public_path__ + "static/media/Snd44.998e082a.mp3";